// Internal module imports
import { HttpClient } from '../utils/httpClient';

const PATH = {
    readAll: '/root/documents',
    saveDocument: '/root/documents',
    getDocument: '/root/documents',
    uploadFiles: '/root/documents/upload-files',
    removeFile: '/root/documents/remove-file',
    getDetails: '/root/documents/details',
};

const GetData = (start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.readAll).then(callback).catch(error).finally(next);
};

const SaveDocument = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(PATH.saveDocument, payload).then(callback).catch(error).finally(next);
};

const GetDocument = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getDocument}/${id}`).then(callback).catch(error).finally(next);
};

const UploadFiles = (payload, callback, error) => {
    return HttpClient.post(PATH.uploadFiles, payload).then(callback).catch(error);
};

const RemoveFile = (payload, start, callback, error, next) => {
    start();
    return HttpClient.put(PATH.removeFile, payload).then(callback).catch(error).finally(next);
};

const GetFiles = (id, callback, error) => {
    return HttpClient.get(`${PATH.getDocument}/${id}`).then(callback).catch(error).finally();
};

const GetDetails = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.getDetails, { params: params }).then(callback).catch(error).finally(next);
};

export const RootDocumentsService = {
    GetData,
    GetDocument,
    SaveDocument,
    UploadFiles,
    RemoveFile,
    GetFiles,
    GetDetails,
};
